import { combineReducers } from 'redux'

import { reducer as toastrReducer } from 'react-redux-toastr'

import ui from './ui'
import shipments from './shipments'
import profile from './profile'
import times from './times'
import arrivals from './arrivals'
import routes from './routes'
import drivers from './drivers'
import tours from './tour'
import collations from './collations'
import tourOverviews from './tourOverview'
import todoList from './todoList'
import collectionTours from './collection/tours'
import shipmentAndDriverEstimation from './shipmentAndDriverEstimation'
import intervalTasks from './intervalTasks'
import freezerManagement from './freezerManagement/index'
import hubLogs from './hublogs'
import warehouse from './warehouse'
import reasonCodeUnscannable from './reasonCodeUnscannable'
import networkType from './networkType'
import greenRegions from './greenRegions'

const rootReducer = combineReducers({
  collection: combineReducers({
    tour: collectionTours,
  }),
  ui,
  shipments,
  profile,
  times,
  arrivals,
  routes,
  drivers,
  tours,
  collations,
  toastr: toastrReducer,
  tourOverviews,
  todoList,
  shipmentAndDriverEstimation,
  intervalTasks,
  freezerManagement,
  hubLogs,
  warehouse,
  reasonCodeUnscannable,
  networkType,
  greenRegions,
})

export default rootReducer
